import {
  EcommercePerformanceAction,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_FAIL,
  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_SUCCESS,
  LoadEcommercePerformanceReportNetSales,
  LoadEcommercePerformanceReportNetSalesFail, LoadEcommercePerformanceReportNetSalesSuccess
} from "../actions";


export interface IEcommercePerformanceReportNetSalesEntityState {
  netSalesData: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommercePerformanceReportNetSalesState {
  entities: { [websiteId: number]: IEcommercePerformanceReportNetSalesEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommercePerformanceReportNetSalesState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommercePerformanceReportNetSalesState = initialState, action: EcommercePerformanceAction): IEcommercePerformanceReportNetSalesState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES:
      payload = (<LoadEcommercePerformanceReportNetSales>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_SUCCESS:
      payload = (<LoadEcommercePerformanceReportNetSalesSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            netSalesData: payload.netSalesData,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_FAIL:
      payload = (<LoadEcommercePerformanceReportNetSalesFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
